module.exports = __webpack_public_path__ + "static/media/bracing_angle_1100.9f47ec9f.webp";